import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import bcrypt from "bcryptjs";
import { Image } from "antd";
import { UserOutlined, LockOutlined, UnlockOutlined, CloseOutlined, CloseCircleFilled } from "@ant-design/icons";
import "./Login.css";
import { ActivePage } from "../../Components/SideBar/Sidebar";
const Login = () => {
  const location = useLocation();
  const { logoutMsg } = location.state ? location.state : "no";
  const [showSignup, setShowsignup] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [result, setResult] = useState("");
  const [showSubmitError, setSubmitError] = useState(false);
  const [showNetworkError, setShowNetworkError] = useState(false)
  const [mailPassError, setMailPassError] = useState(false)
  const [errorMsg] = useState("Enter correct credentials");
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(<LockOutlined style={{ color: "blue" }}></LockOutlined>)
  const [showSpinner, setShowSpinner] = useState(false)
  const [showLogoutDiv, setShowLogoutDiv] = useState(false)
  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 6);

  const ChangeEmail = (event) => {
    setSubmitError(false);
    setShowNetworkError(false)
    setMailPassError(false)
    setEmail(event.target.value);
  };
  const ChangePassword = (event) => {
    setSubmitError(false);
    setShowNetworkError(false)
    setMailPassError(false)
    setPassword(event.target.value);
  };

  const handleIcon = () => {
    if (type === 'password') {
      setType('text')
      setIcon(<UnlockOutlined style={{ color: "blue" }}></UnlockOutlined>)
    }
    else {
      setType('password')
      setIcon(<LockOutlined style={{ color: "blue" }}></LockOutlined>)
    }
  }

  const submitForm = (event) => {
    event.preventDefault();
    setSubmitError(false);
    setMailPassError(false)
    setShowNetworkError(false)
    setShowLogoutDiv(false)
    if (email.length === 0 || password.length === 0) {
      setMailPassError(true)
      setShowSpinner(false)
    }
    else {
      setShowSpinner(true)
      const hashedPassword = bcrypt.hashSync(password, 10);
      fetch(`${process.env.REACT_APP_BASE_URL}Login/validateuser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email, hashedPassword }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.token !== null) {
            onSubmitSuceess({
              Token: response.token,
              FName: response.firstName,
              LName: response.lastName,
              Role: response.role,
            });
          }
          else {
            onSubmitFailure(errorMsg);
          }
        })
        .catch((error) => {
          // console.log('newtork issue')
          setShowSpinner(false)
          setShowNetworkError(true)
        })
    }
  };
  const onSubmitSuceess = (props) => {
    let jwtToken = props.Token;
    let Firstname = props.FName;
    let Lastname = props.LName;
    let Role = props.Role;
    const { history } = props.Token;

    Cookies.set("jwt_token", jwtToken);
    Cookies.set("first_name", Firstname);
    Cookies.set("last_name", Lastname);
    Cookies.set("UserLogin", email);
    Cookies.set("Role", Role);
    // Cookies.set("Date", currentDate);
    if (Role === "Super User" ) {
      window.location.href = "/admin-dashboard";
    }
    else {
      window.location.href = "/dashboard";
    }
    ActivePage("1");
  };
  const onSubmitFailure = (errorMsg) => {
    setShowSpinner(false)
    setSubmitError(true);
  };

  useEffect(() => {
    if (logoutMsg === "yes") {
      setShowLogoutDiv(true)
    }
    const jwtToken = Cookies.get("jwt_token");
    const userRole = Cookies.get("Role");
    const reqRole = "Super User"
    if (jwtToken !== undefined && userRole === reqRole) {
      window.location.href = "/admin-dashboard";
    }
    else if (jwtToken !== undefined && userRole === "User") {
      window.location.href = "/dashboard";
    }
  }, []);
  const goToResetPage = () => {
    window.location.href = "/resetpassword";
  };

  return (
    <>
      <div className="fullscreen">
        <div className="login-col">
          {showLogoutDiv && <div className="logout-msg-class">
            <span className="logout-msg">You've successfully logged out!</span>
            <span className="logout-close"><CloseCircleFilled style={{ marginTop: 5, cursor: "pointer" }} onClick={() => setShowLogoutDiv(false)} /></span>
          </div>}
          <div className="form-border">
            {showSpinner &&
              <marquee width="100%" direction="right" scrollamount="40" className='progress'>
                <div className="marquee-div"> </div>
              </marquee>
            }
            <div className={showSpinner ? "blur-form" : "form-div"}>
              <h4 className="card-title">INTIME</h4>
              <form className="Loginform-class" onSubmit={(e) => submitForm(e)}>
                <div className="login-signup">
                  <span style={{ marginLeft: 5 }}>
                    <UserOutlined style={{ color: "blue" }}></UserOutlined>
                  </span>
                  <input
                    type="text"
                    id="email"
                    placeholder="Enter your Email"
                    className="email-class"
                    value={email}
                    onChange={(e) => ChangeEmail(e)}
                  />
                </div>
                <div className="login-signup">
                  <span style={{ marginLeft: 5 }} onClick={handleIcon}>
                    {icon}
                  </span>
                  <input
                    type={type}
                    id="password"
                    placeholder="Enter your Password"
                    className="email-class"
                    onChange={(e) => ChangePassword(e)}
                  />
                </div>
                {showSubmitError && (
                  <div className="row-three" style={{ color: "#FF0000" }}>
                    <p style={{ color: "#FF0000" }}>
                      *Enter valid credentials
                    </p>
                  </div>
                )}
                {mailPassError && (
                  <div className="row-three" style={{ color: "#FF0000" }}>
                    <p style={{ color: "#FF0000" }}>
                      *Email/ Password should not be empty
                    </p>
                  </div>
                )}
                {showNetworkError && (
                  <div className="row-three" style={{ color: "#FF0000" }}>
                    <p style={{ color: "#FF0000" }}>
                      Please check your newtork
                    </p>
                  </div>
                )}
                <div className="row-four">
                  <div className="forgot-remember">
                    <div className="checkclass">
                      <input type="checkbox" className="checkme" />
                      &nbsp;
                      <span className="checkmark">Remember me</span>
                    </div>
                    <div className="checkclass">
                      <Link
                        to={{ pathname: "/resetpassword" }}
                        className="forgot-button"
                      >
                        Forgot Password
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row-five">
                  <button type="submit" className={showSpinner ? "signin-blur" : "signin-button"}>
                    Sign In
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* <div className="space-col"></div> */}
        <div className="image-fullcol">
          <Image
            src="./Images/7566.jpg"
            style={{
              border: "none",
              width: "80% ",
              // paddingTop: 120,
              // margin:"auto",
              height: "110%",
            }}
            showPreviewIcon={false}
            preview={false}
          />
        </div>
      </div>
    </>
  );
};
export default Login;
